<template>
  <div class="tm-row uk-flex uk-flex-wrap uk-flex-middle uk-visible-hover-inline"
    :class="{ 'uk-text-muted': !subscribed && !installed }"
    @click="operative && (selected = !selected)">
    <div class="uk-width-large-4-10 uk-width-medium-1-2 uk-width-small-1-2 uk-text-truncate tm-cursor-default">
      <!-- STATE / SELECT -->
      <span class="uk-icon-justify">
        <i v-if="operative && !selected && !isMobile"
          :class="{
            'tm-visible-toggle': !selected,
            'uk-text-success': installed && enabled && !deprecated,
            'uk-text-warning': installed && enabled && outdated && !deprecated,
            'uk-text-danger': installed && enabled && deprecated,
            'uk-icon-check': installed,
            'uk-icon-level-down': outdated,
            'uk-icon-exclamation': deprecated,
            'uk-icon-unlock uk-text-muted': subscribed && !installed
          }">
        </i>
        <i v-if="operative"
          :class="{
            'uk-hidden': !selected && !isMobile,
            'uk-icon-square-o': !selected,
            'uk-icon-check-square-o': selected
          }">
        </i>
        <i v-else class="uk-icon-lock"></i>
      </span>
      <!-- TITLE -->
      {{ title }}
    </div>
    <!-- VERSION -->
    <div class="uk-width-large-2-10 uk-width-small-1-2 uk-text-center tm-medium-right uk-hidden-medium"
      :class="{
        'uk-text-success': installed && enabled,
        'uk-text-warning': outdated && enabled,
        'uk-text-danger': deprecated && enabled
      }">
      {{ installed ? installedVersion : version }}
      <span v-if="installed && outdated">
        / {{ version }}
      </span>
    </div>
    <!-- BUTTONS -->
    <div class="uk-width-large-4-10 uk-width-medium-1-2 uk-flex uk-flex-inline uk-flex-right uk-hidden-small">
      <!-- uninstall -->
      <tm-button
        v-if="type !== 'Core' && installed"
        class="uk-invisible uk-button-danger uk-margin-small-left"
        icon="trash-o"
        :title="'Uninstall'"
        @click.stop="$parent.uninstall([name])">
      </tm-button>
      <!-- toggle state -->
      <tm-button
        v-if="installed && (type === 'Plugin' || type === 'Extension') && type !== 'Core'"
        class="uk-margin-small-left"
        :class="{
          'uk-invisible': !deprecated,
          'uk-button-primary': deprecated
        }"
        :icon="enabled ? 'toggle-on' : 'toggle-off'"
        :title="'Toggle Status'"
        @click.stop="$parent.toggle([name])">
      </tm-button>
      <div v-if="subscribed" class="uk-button-group uk-margin-small-left">
        <!-- download -->
        <tm-button half
          :disabled="offline"
          style="primary"
          icon="download"
          :title="'Download'"
          @click.stop="$parent.download([name])">
        </tm-button>
        <!-- install -->
        <tm-button half
          :disabled="offline"
          style="primary"
          :icon="!outdated && installed
            ? 'retweet'
            : 'bolt'"
          :title="!outdated && installed
            ? 'Reinstall'
            : (installed ? 'Update' : 'Install')"
          @click.stop="$parent.install([name])">
        </tm-button>
      </div>
      <!-- subscribe -->
      <tm-button
        v-if="!subscribed && !deprecated"
        class="uk-button-primary uk-margin-small-left"
        icon="ticket"
        title="Subscribe"
        :href="url">
      </tm-button>
    </div>
    <!-- SEPARATOR -->
    <div class="uk-width-1-1 uk-margin-small-top"><hr></div>
  </div>
</template>

<script>
export default {
  name: 'Extension',
  props: {
    name: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    installed: {
      type: Boolean,
      default: false
    },
    installedVersion: {
      type: String,
      default: ''
    },
    deprecated: {
      type: Boolean,
      default: false
    },
    subscribed: {
      type: Boolean,
      default: false
    },
    downloadUrl: {
      type: String,
      default: ''
    },
    enabled: {
      type: Boolean,
      default: true
    },
    version: {
      type: String,
      default: ''
    },
    outdated: {
      type: [Boolean],
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    offline: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // can actions be performed
    // with this extension
    operative: function () {
      return this.installed || this.subscribed
    },
    isMobile: function () {
      return window.screen.width <= 960
    }
  }
}
</script>

<style lang="less">
@import "../../../node_modules/uikit/src/less/core/variables.less";

@media (max-width: @breakpoint-mini-max) {
  /* Halves */
  .uk-width-small-1-2,
  .uk-width-medium-1-2 {
    width: 50%;
  }
}
@media (max-width: @breakpoint-medium-max) {
  .tm-medium-right {
    text-align: right !important;
  }
}
</style>



/** WEBPACK FOOTER **
 ** Extension.vue?6fd6fa2a
 **/